import AVdxbAlert from './index.vue';

AVdxbAlert.install = app => {
  app.component(AVdxbAlert.name, AVdxbAlert);
};

export default AVdxbAlert;
